<div class="container-fluid">
  <div class="row table-wrapper">
    <mat-card class="modern-table-card">
      <mat-card-header class="mat-card-header">
        <!-- <mat-form-field class="search-field">
        <mat-label>Search Accounts</mat-label>
        <input
          matInput
          [type]="'text'"
          (change)="searchAccountQuery($event)"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field> -->
        <div class="table-toolbar p-2 mt-3 mb-3">
          <mat-card-title class="lead"
            >Accounting - <span class="text-muted">Account</span>
          </mat-card-title>
          <!-- TODO: Remove after design is confirmed -->
          <!-- Use matPrefix to position the image on the left side -->
          <!-- <mat-form-field >
          <mat-label>Date range</mat-label>
          <span matPrefix (click)="openDatePicker()">
            <img src="../../../assets/icons/shooting-schedule.png" alt="Date Icon" class="date-icon" />
          </span>
          <mat-date-range-input [rangePicker]="bookingPicker" [min]="minDate" [max]="maxDate"
            (click)="openDatePicker()">
            <input matStartDate placeholder="Start date" [ngModel]="startDate" (dateChange)="onDateRangeChange()">
            <input matEndDate placeholder="End date" [ngModel]="endDate" (dateChange)="onDateRangeChange()">
          </mat-date-range-input>
          <mat-date-range-picker #bookingPicker></mat-date-range-picker>
        </mat-form-field> -->

          <!-- <button mat-icon-button (click)="exportData()" matTooltip="Export">
        <img src="../../../assets/icons/export-svg.svg" alt="Export Icon" class="import-icon" />
      </button> -->

          <button
            mat-icon-button
            (click)="importData(selection)"
            matTooltip="Import"
          >
            <img
              src="../../../assets/icons/Import.png"
              alt="Import Icon"
              class="import-icon"
            />
          </button>

          <button mat-icon-button [matMenuTriggerFor]="columnMenu">
            <mat-icon>settings</mat-icon>
          </button>

          <div class="row">
            <mat-menu #columnMenu="matMenu">
              <div class="column-menu-content">
                @for (col of columns; track col) {
                  @if (col.key !== "select" && col.isCheckbox !== true) {
                    <mat-checkbox
                      [checked]="visibleFieldKeys.includes(col.key)"
                      (change)="toggleColumnVisibility(col.key)"
                    >
                      <span class="settings-menu">{{ col.label }}</span>
                    </mat-checkbox>
                  }
                }
              </div>
            </mat-menu>
          </div>
        </div>
      </mat-card-header>
      <mat-card-content class="table-layout-content">
        <!-- Uncomment once requirement is clear -->
        <!-- <hr><br>
      <section class="example-container mat-elevation-z8" tabindex="0">
        <div class="row">
          <div class="col">
            <highcharts-chart [Highcharts]="Highcharts" [options]="barChartOptions"></highcharts-chart>
          </div>
          <div style="width: 100%; height: 400px; margin: 0 auto;">
            <highcharts-chart [Highcharts]="Highcharts" [options]="lineChartOptions"
            style="width: 100%; height: 400px; display: block;"></highcharts-chart>
          </div>
        </div>
      </section>
      <hr>
        <br> -->

        <div class="table-container-scroll mat-elevation-z2">
          <section class="example-container table-scroll-region" tabindex="0">
            <mat-table
              [dataSource]="sortedData"
              matSort
              class="custom-column-divider modern-table"
              matSort
              (matSortChange)="handleSortChange($event)"
            >
              @for (col of columns; track col) {
                <ng-container [matColumnDef]="col.key">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    [sticky]="col.sticky"
                    class="table-header-cell"
                  >
                    @if (col.key === "select") {
                      <mat-checkbox
                        (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="
                          selection.hasValue() && !isAllSelected()
                        "
                        [aria-label]="checkboxLabel()"
                      >
                      </mat-checkbox>
                    }
                    @if (col.sortable) {
                      <span [mat-sort-header]="col.key">{{ col.label }}</span>
                    }
                    @if (!col.sortable) {
                      <span>{{ col.label }}</span>
                    }
                  </th>
                  <td mat-cell *matCellDef="let row" class="table-data-cell">
                    @if (col.key === "select") {
                      <mat-checkbox
                        (change)="selection.toggle(row)"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)"
                      >
                      </mat-checkbox>
                    }
                    @if (col.key === "actions") {
                      <div>
                        <img
                          src="../../../../assets/icons/view_icon.png"
                          (click)="openAccountDetails(row)"
                          width="28"
                          alt="View details"
                          class="src p-1"
                        />
                        <img
                          src="../../../../assets/icons/delete_icon.png"
                          (click)="deleteAccount(row)"
                          width="20"
                          alt="Delete"
                          class="src p-1"
                        />
                      </div>
                    }
                    @switch (col.key) {
                      @case ("isClient") {
                        <span>
                          @if (col.key === "isClient") {
                            <img
                              src="../../../../assets/icons/klant.png"
                              alt="Client"
                              width="20"
                              matTooltip="Client"
                            />
                          } @else {
                            <img
                              src="../../../../assets/icons/vakman.png"
                              alt="Handyman"
                              width="20"
                              matTooltip="Handyman"
                            />
                          }
                        </span>
                      }
                      @case ("fullAddress") {
                        <span>
                          {{ row.address }}, {{ row.city }}, {{ row.postCode }}
                        </span>
                      }
                      @case ("status") {
                        <span
                          class="table-data-text"
                          [ngClass]="{
                            'imported-status': row[col.key] === 'Imported',
                            'error-status':
                              row[col.key] === 'Error' ||
                              row[col.key] === 'Failed',
                            'default-status':
                              row[col.key] !== 'Imported' &&
                              row[col.key] !== 'Error' &&
                              row[col.key] !== 'Open' &&
                              row[col.key] !== 'Failed',
                          }"
                        >
                          @if (row[col.key] === "Imported") {
                            <img
                              src="../../../../../assets/icons/Imported.png"
                              alt=""
                            />
                          }
                          @if (row[col.key] === "Error") {
                            <img
                              src="../../../../../assets/icons/Failed.png"
                              alt=""
                            />
                          }
                          @if (row[col.key] === "Open") {
                            <img
                              width="60"
                              src="../../../../../assets/icons/Open.png"
                              alt=""
                            />
                          }
                          @if (
                            row[col.key] !== "Imported" &&
                            row[col.key] !== "Error" &&
                            row[col.key] !== "Open"
                          ) {
                            {{ row[col.key] }}
                          }
                        </span>
                      }
                      @default {
                        <span>
                          {{ row[col.key] }}
                        </span>
                      }
                    }
                  </td>
                </ng-container>
              }

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
                class="modern-table-header-row"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="modern-table-data-row"
              ></tr>

              <tr class="mat-row no-data-row" *matNoDataRowDef>
                <td class="mat-cell" [attr.colspan]="columns.length">
                  No data matching the filter.
                </td>
              </tr>
            </mat-table>
          </section>

        </div>

        <app-pagination-table
          class="rounded-lg bg-white table-pagination-fixed"
          [totalResults]="totalResults"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageOffset]="pageOffset"
          (pageChange)="onPageChange($event)"
        >
        </app-pagination-table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
